export const getCurrentSalesforceSyncStatus = state => state.salesforce.status;
